<template>
  <div class="register-layout">
    <header style="margin-bottom: 20px">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="16">
          <div class="title">{{ $event.EventName }}</div>
          <div class="s-title">{{ $event.Organizer }}</div>
          <div class="item">{{ $event.StartDate }} - {{ $event.EndDate }}</div>
          <div class="item">{{ $event.Address }}</div>
          <div style="margin-bottom: 20px"></div>
        </el-col>
        <el-col :xs="24" :sm="8">
          <banner v-if="$event.Banner">
            <img style="width: 100%" :src="$event.Banner" />
          </banner>
        </el-col>
      </el-row>
    </header>

    <el-row :gutter="20">
      <el-col :xs="24" :sm="16">
        <nav class="breadcrumb">
          <template v-for="(it, index) in $pages.filter((x) => x.Name !== 'login')" :key="it.ID">
            <div class="item" :class="{ 'is--active': it.Name === name }">
              <i>{{ index + 1 }}</i>
              <span>{{ it.Title }}</span>
            </div>
          </template>
        </nav>

        <el-card class="register-form">
          <template #header>
            <slot name="header">注册信息</slot>
          </template>

          <!-- <slot name="nav" v-if="$slots.nav"></slot> -->
          <div class="top" v-if="pageConfig && pageConfig.layout && pageConfig.layout.top&&!workbench" v-html="pageConfig.layout.top"></div>
          <slot />
          <div class="buttom" v-if="pageConfig && pageConfig.layout && pageConfig.layout.bottom&&!workbench" v-html="pageConfig.layout.bottom"></div>
          <div class="actions" v-if="nav">
            <template v-if="page.prev">
              <el-button type="primary" plain @click="$router.push({ name: page.prev.Name })" v-if="page.prev != null && page.prev.Name === 'login'">
                {{ $t('registration.btn.cancel') }}
              </el-button>
              <el-button type="primary" plain @click="$router.push({ name: page.prev.Name })" v-else>{{ $t('registration.btn.prev') }}</el-button>
            </template>
            <template v-else-if="name === 'login'">
              <el-button type="primary" plain @click="$router.push({ name: 'index' })">{{ $t('registration.btn.cancel') }}</el-button>
            </template>
            <template v-if="page.next">
              <el-button type="primary" @click="emit('next', page.next.Name)">{{ $t('registration.btn.next') }}</el-button>
            </template>
            <template v-else-if="name === 'confirmation'">
              <el-button type="primary" @click="emit('next', page.next.Name)">{{ $t('registration.btn.personal') }}</el-button>
            </template>
            <template v-else></template>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="8">
        <VSideBar />
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
  import { onMounted, ref, watch, computed, inject } from 'vue'
  import { ArrowDown, ArrowUp } from '@element-plus/icons-vue'
  import { useRegister } from '@/hooks/useRegister'
  import { getInformation } from '@/api/registration'
  import { getPageConfig, getSteps } from '@/api/config'
  import { ElMessage, ElLoading } from 'element-plus'
  import Loading from '@/components/Loading'
  import VSideBar from '@/views/register/home/1/sidebar.vue'

  const props = defineProps({
    name: {
      type: String,
      default: '',
    },
    nav: {
      type: Boolean,
      default: true,
    },
    workbench: {
      type: Boolean,
      default: false,
    },
  })

  const emit = defineEmits(['mounted', 'next'])
  const $pages = inject('$steps')
  const $event = inject('$event')
  const $config = inject('$config')

  const page = computed(() => {
    let obj = { current: null, prev: null, next: null }
    for (var i = 0, len = $pages.value.length; i < len; i++) {
      let it = $pages.value[i]
      if (it.Name == props.name) {
        obj.current = it
        if (i > 0) {
          obj.prev = $pages.value[i - 1]
        }
        if (i < len - 1) {
          obj.next = $pages.value[i + 1]
        }
        break
      }
    }
    return obj
  })
</script>

<style lang="scss" scoped>
  .register-layout {
    .el-card {
      border: solid 1px var(--el-color-primary-light-7) !important;
      box-shadow: none;
      margin-bottom: 20px;
      :deep() {
        > .el-card__header {
          padding: 12px 18px;
          background-color: var(--el-color-primary-light-8);
          border-bottom: solid 1px var(--el-color-primary-light-7);
          display: flex;
          justify-content: flex-start;
          align-items: center;
          color: var(--el-color-primary);
          font-size: 16px;
          font-weight: bold;
        }
      }
    }
  }
  .actions {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .breadcrumb {
    list-style: none;
    box-sizing: border-box;
    font-size: 0;
    overflow: hidden;
    margin: 0;
    padding: 0;
    //--breadcrumb-width: 100px;
    --breadcrumb-height: 43px;
    --breadcrumb-color: #f5f5f5;
    --breadcrumb-color-active: var(--el-color-primary);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    margin-bottom: 20px;
    .item {
      flex: 1;
      margin: 0;
      padding: 0;
      list-style: none;
      max-width: 150px;
      box-sizing: border-box;
      cursor: pointer;
      box-sizing: border-box;
      color: var(--el-color-primary);
      display: block;
      background-color: var(--breadcrumb-color);
      text-decoration: none;
      position: relative;
      height: var(--breadcrumb-height);
      text-align: center;
      margin-right: calc(var(--breadcrumb-height) / 2 * 0.25 + 4px);
      font-size: 14px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      box-sizing: border-box;
      color: #323335;
      padding-left: 4px;
      i {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        background: rgba(53, 59, 85, 0.1);
        line-height: 22px;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        color: #353b55;
        margin-left: 3px;
      }
      span {
        font-size: 12px;
        line-height: 22px;
        font-weight: bold;
        padding-left: 3px;
        padding-right: 6px;
        white-space: nowrap;
      }
      &::before,
      &::after {
        content: '';
        position: absolute;
        top: 0;
        border: 0 solid var(--breadcrumb-color);
        border-width: calc(var(--breadcrumb-height) / 2 + 1px) calc(var(--breadcrumb-height) / 2 * 0.25);
        width: 0;
        height: 0;
      }
      &::before {
        left: calc(-1 * var(--breadcrumb-height) / 2 * 0.25);
        border-left-color: transparent;
      }
      &::after {
        left: 100%;
        border-color: transparent;
        border-left-color: var(--breadcrumb-color);
      }
      &.is--active {
        color: #fff;
        background-color: var(--breadcrumb-color-active);
        &::after {
          border-color: transparent;
          border-left-color: var(--breadcrumb-color-active);
        }
        &::before {
          border-color: var(--breadcrumb-color-active);
          border-left-color: transparent;
        }
        color: #fff;
        i {
          background: #fff;
          color: var(--breadcrumb-color-active);
        }
      }
      &:first-child {
        &::before {
          display: none;
        }
        border-radius: 4px 0 0 4px;
      }
      &:last-child {
        margin-right: 0;
        border-radius: 0 4px 4px 0;
        &::after {
          display: none;
        }
      }
    }
  }

  @media screen and (max-width: 900px) {
    .breadcrumb {
      .item {
        padding-left: 3px;
        i {
          display: none;
        }
      }
    }
  }
</style>
